import type { OrgRole } from "~/graphql/generated";

export const ROLE_LABELS: Record<OrgRole, string> = {
  OWNER: "Owner",
  ADMIN: "Admin",
  SKIPPER: "Skipper",
  CREW: "Crew",
  INSTRUCTOR: "Instructor",
  STUDENT: "Student",
  OBSERVER: "Observer",
};

export const ROLE_COLORS: Record<OrgRole, string> = {
  OWNER: "var(--color-purple)",
  ADMIN: "var(--color-primary)",
  SKIPPER: "var(--color-primary)",
  CREW: "var(--color-accent)",
  INSTRUCTOR: "var(--color-warning)",
  STUDENT: "var(--color-success)",
  OBSERVER: "var(--neutral-400)",
};

export function initials(firstName: string, lastName: string): string {
  return `${firstName[0] ?? ""}${lastName[0] ?? ""}`.toUpperCase() || "?";
}
